export default {
    token: null
}
